import React from "react";
import Sidebar from "@/components/Sidebar";

export default function AppShell({ children }) {
  return (
    <div className="min-h-screen bg-[#0B1120] grid-noise flex">
      <Sidebar />
      <main className="flex-1 min-w-0">
        {children}
      </main>
    </div>
  );
}
